
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const CardIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 49C21.567 49 20 50.567 20 52.5C20 54.433 21.567 56 23.5 56H40.5C42.433 56 44 54.433 44 52.5C44 50.567 42.433 49 40.5 49H23.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M88 30.5L88 65.5C88 71.299 83.299 76 77.5 76H18.5C12.701 76 8 71.299 8 65.5L8 30.5C8 24.701 12.701 20 18.5 20H77.5C83.299 20 88 24.701 88 30.5ZM81 65.5L81 43H15L15 65.5C15 67.433 16.567 69 18.5 69H77.5C79.433 69 81 67.433 81 65.5ZM81 30.5V36H15V30.5C15 28.567 16.567 27 18.5 27L77.5 27C79.433 27 81 28.567 81 30.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5 72.5H77.5C81.366 72.5 84.5 69.366 84.5 65.5V30.5C84.5 26.634 81.366 23.5 77.5 23.5L18.5 23.5C14.634 23.5 11.5 26.634 11.5 30.5L11.5 65.5C11.5 69.366 14.634 72.5 18.5 72.5Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.5 49C21.567 49 20 50.567 20 52.5C20 54.433 21.567 56 23.5 56H40.5C42.433 56 44 54.433 44 52.5C44 50.567 42.433 49 40.5 49H23.5Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M88 30.5L88 65.5C88 71.299 83.299 76 77.5 76H18.5C12.701 76 8 71.299 8 65.5L8 30.5C8 24.701 12.701 20 18.5 20H77.5C83.299 20 88 24.701 88 30.5ZM81 65.5L81 43H15L15 65.5C15 67.433 16.567 69 18.5 69H77.5C79.433 69 81 67.433 81 65.5ZM81 30.5V36H15V30.5C15 28.567 16.567 27 18.5 27L77.5 27C79.433 27 81 28.567 81 30.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5 72.5H77.5C81.366 72.5 84.5 69.366 84.5 65.5V30.5C84.5 26.634 81.366 23.5 77.5 23.5L18.5 23.5C14.634 23.5 11.5 26.634 11.5 30.5L11.5 65.5C11.5 69.366 14.634 72.5 18.5 72.5Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
